import BulkEditComputersModal from './bulk-edit-computers-modal';

export default BulkEditComputersModal;
